
/**
 * 利用文件流下载文件
 * @param {Blob} blob 文件流
 */
export default (blob, name = '测试', fileType = 'xlsx') => {
  const url = window.URL.createObjectURL(new Blob([blob]))
  const link = document.createElement('a')
  link.href = url
  link.download = `${name}${fileType ? '.' + fileType : ''}`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}
